<template>
	<section class="vx-row justify-center w-full py-6 md:py-12 lg:py-24 mb-24 mx-1">
		<div class="vx-col w-full md:w-2/3 lg:w-1/2">
			<div class="flex mb-4">
				<router-link :to="`/campaign/view/${$route.params.slug_and_id}`">
					<feather-icon icon="ChevronLeftIcon" svgClasses="text-primary mr-4"></feather-icon>
				</router-link>
				<strong class="text-primary"><small>Masukan Nominal Donasi</small></strong>
			</div>
			<vx-card>
				<div class="mb-8">
					<strong class="block mb-4"><small>Nominal</small></strong>
					<div class="relative">
						<small class="absolute rounded block bg-grey h-full py-2" style="z-index:99;top:0;left:0;"><strong class="block px-2">Rp.</strong></small>
						<vs-input v-validate="'required'" @keyup.enter="submit" name="num" class="rounded w-full pl-8" v-model="num" />
					</div>
					<span class="text-danger text-sm mt-6" v-show="errors.has('num')">{{ errors.first('num') }}</span>
				</div>
				<vs-button size="large" @click.prevent="submit" class="w-full"><small class="text-white">Lanjut Pembayaran</small></vs-button>
			</vx-card>
		</div>
	</section>
</template>
<script>
// For custom error message
import { Validator } from 'vee-validate'
const dict = {
	  custom: {
	    num: {
	      required: 'Harap masukan nominal',
	      alpha: 'Harap masukan angka'
	    }
	  }
};

// register custom messages
Validator.localize('en', dict)

const minTransaction = 10000

export default {
  watch: {
    num: {
      handler (val) {
        if (val !== 0 && val) {
          this.availableAmount.map(item => {
            item.class = null;
          });
          this.realNum = this.replaceAll(this.num, '.', '');
          this.num = this.formatRupiah(this.num);
        }
      },
      deep: true
    }
  },
  data: () => ({
    availableAmount: [{num: '2000', class:''}, {num: '50000', class:''}, {num: '10000', class:''}, {num: '100000', class:''}],
    num: null,
    realNum: null,
    campaign: {}
  }),
  methods: {
    replaceAll (target, search, replaceTo) {
      return target.split(search).join(replaceTo)
    },
    submit () {
      this.$validator.validateAll().then(res => {
        if (res) {

          // Min transaction 10k
          if(this.realNum < minTransaction) {
            this.$vs.notify({
              title: 'Minimal Donasi Rp 10.000',
              text: '',
              color: 'warning',
              position: 'top-right'
            });

            return false;
          }

          this.$vs.loading();

          this.$store.dispatch('campaign/setTransactionAmount', this.realNum)
            .then(() => {
              this.$vs.loading.close();
              let nextLink = `/campaign/checkout/${this.$route.params.slug_and_id}?amount=${this.realNum}`;
              if(this.$route.query.ref) {
                nextLink += `&ref=${this.$route.query.ref}`;
              }

              this.$router.push(nextLink);
            })
            .catch(e => {
              this.$vs.loading.close();
              console.error(e);
              return false;
            });
        }
      })
    },
    selectNum (i) {
      // this.$vs.loading()
      this.availableAmount.map(item => {
        item.class = null
      })
      // this.num = this.availableAmount[i].num
      this.availableAmount[i].class = 'active-num';

      const num = parseFloat(this.availableAmount[i].num.replace('.', ''));
      setTimeout(() => {
        this.$vs.loading.close();
        let nextLink = `/campaign/${this.campaign.id}/checkout?amount=${num}`;
        if(this.$route.query.ref) {
          nextLink += `&ref=${this.$route.query.ref}`;
        }

        this.$router.push(nextLink);
      }, 1000);
    },
  },
  created () {
    this.checkVerifyAccount();

    this.availableAmount.forEach(item => {
      item.num = this.formatRupiah(item.num);
    });

    // get id from slug
		const arrSlug = this.$route.params.slug_and_id.split('-'),
				id = Buffer.from(arrSlug[ arrSlug.length - 1 ], 'base64').toString();

    this.$store.dispatch('campaign/getDetail', id)
    .then(campaign => {
      Object.assign(this.campaign, campaign);
    });
  }
}
</script>
<style>
	#con-num .vs-input--input {
		padding: 3rem;
	}
</style>